import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Button } from '../../atoms/button';

type Props = {
  personId: number;
  isLiked: boolean;
  isLikeSubmitting?: boolean;
  isLikeCountLoading?: boolean;
  isOutOfLike: boolean;
  onLike: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  personId,
  isLiked,
  isLikeSubmitting = false,
  isLikeCountLoading = false,
  isOutOfLike,
  onLike,
}) => (
  <section className="scout-like-panel">
    <h2 className="scout-like-panel__title">気になる</h2>
    <p className="scout-like-panel__description">候補者にあなたが気になっていることを伝えます</p>
    <Button
      className={classNames('scout-like-panel__button', { disabled: isLiked || isLikeCountLoading || isOutOfLike })}
      onClicked={onLike}
      personId={personId}
      defaultValue={isLiked ? '気になる済み' : isLikeSubmitting ? '送信中' : '気になる'}
      disabled={isLiked || isLikeSubmitting || isLikeCountLoading || isOutOfLike}
    />
  </section>
);
